export class LoginModel{
    public email: string = "";
    public password:string = "";
}

export class LoginTokenModel{
    public email: string = "";
    public token: string = "";
    public username: string = "";
    public is_admin: boolean = false;
}